import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { from, fromEvent, Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil, tap } from 'rxjs/operators';

interface Option { key: string, value: string }

@Component({
    selector: 'doc-form-input',
    templateUrl: 'input.component.html',
    styleUrls: ['input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DocInputComponent),
        multi: true
    }]
})

export class DocInputComponent implements ControlValueAccessor, OnInit, AfterViewInit, OnDestroy, OnChanges {
    private onDestroyed$ = new Subject();

    @ViewChild('inputEl') inputEl: ElementRef;

    @Input() parentForm: UntypedFormGroup;
    @Input() controlName: string;

    @Input('placeholder') placeholder = '';
    @Input('label') label = '';
    @Input('labelbold') labelbold:boolean = false;
    @Input('type') type = 'text';
    @Input('maxlength') maxLength;
    @Input('minLength') minLength;
    @Input('isPassword') isPassword;
    @Input('icon') icon;
    @Input('options') options;
    @Output() valueChangeEvent: EventEmitter<string> = new EventEmitter();

    value: string = '';
    changed = (value: any) => {
        this.valueChangeEvent.emit(value);
    };
    touched = () => { };
    disabled: boolean;

    filteredOptions: Option[];

    input$: Observable<Option[]>;

    constructor() { }

    ngOnInit(): void { }

    ngAfterViewInit() {
        this.input$ = fromEvent(this.inputEl.nativeElement, 'input');

        this.input$
            .pipe(
                takeUntil(this.onDestroyed$),
                map((event: any) => this._filter(event.srcElement.value))
            ).subscribe((values: any) => {
                this.filteredOptions = values;
            })
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.options) {
            this.options = changes.options.currentValue;
            this.filteredOptions = this.options;
        }
    }

    writeValue(value: any): void {
        this.value = value ? value : '';
        if (this.inputEl) {
            if (this.inputEl.nativeElement.value != this.value) {
                this.inputEl.nativeElement.value = this.value;
            }
        }
    }
    registerOnChange(fn: any): void {
        this.changed = fn;
    }
    registerOnTouched(fn: any): void {
        this.touched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    togglePassword() {
        this.type = this.type === 'text' ? 'password' : 'text';
    }

    private _filter(value: string): Option {
        const filterValue = value.toLowerCase();
        if (this.options) {
            return this.options.filter(option => option.value.includes(filterValue));
        } else {
            return;
        }
    }

    optionSelected(event) {
        this.changed(event.option.value);
    }

    ngOnDestroy() {
        this.onDestroyed$.next();
        this.onDestroyed$.complete();
    }
}

